import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';

const LeasingProtokol = lazy(() =>
  import('@/modules/leasing/LeasingProtokol').then((m) => ({ default: m.LeasingProtokol })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/leasing/$id/protokol',
  component: () => (
    <Suspense fallback={null}>
      <LeasingProtokol />
    </Suspense>
  ),
});
